export const isOptionalOperator = (operator) => typeof operator !== 'undefined' &&
    (['is_empty', 'is_not_empty']).includes(operator);
